<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/intro' }">管理后台</el-breadcrumb-item>
      <el-breadcrumb-item>调解中心简介</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片区域 -->
    <el-card>
      <el-form
        ref="formRef"
        :model="updateForm"
        :rules="updateFormRules"
        label-width="80px"
      >
        <!-- 富文本编辑器组件 -->
        <quill-editor v-model="updateForm.introduce"></quill-editor>
        <!-- 添加商品的按钮 -->
        <el-button type="primary" class="btnUpdate" @click="update"
          >修 改</el-button
        >
      </el-form>
    </el-card>
  </div>
</template>
<script>
export default {
  name: "Index",
  data() {
    return {
      updateForm: {
        id: 0,
        introduce: "",
      },
      updateFormRules: {
        introduce: [
          { required: true, message: "请输入中心简介", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.getCenterIntroduce(1);
  },
  methods: {
    async getCenterIntroduce(id) {
      const { data: res } = await this.$http.get(`introduce/${id}`);
      if (res.meta.status !== 200) {
        console.log(res.meta.msg);
        return this.$message.error("获取中心简介失败！");
      }
      this.updateForm = res.data;
    },
    // 修改简介
    update() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) {
          return this.$message.error("请填写中心简介！");
        }
        const { data: res } = await this.$http.put(
          `introduce/${this.updateForm.id}`,
          { introduce: this.updateForm.introduce }
        );
        if (res.meta.status !== 200) {
          console.log(res.meta.msg);
          return this.$message.error("修改中心简介失败！");
        }
        this.$message.success("修改中心简介成功！");
      });
    },
  },
};
</script>
<style scoped>
.btnUpdate {
  margin-top: 15px;
}
</style>